import { Layout } from '@eventbrite/eds-layout';
import { gettext } from '@eventbrite/i18n';
import { getCanonicalSearchUrl } from '@eventbrite/redux-destination';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import { connect } from 'react-redux';
import { DiscoverState, Location } from '../../../../types/index';
import { LazyRenderer } from '../../../categoryBrowse/components/LazyRenderer';
import { CategoryCarouselSeeMore } from '../../components/CategoryCarouselSeeMore';
import { EmptyState } from '../../components/EmptyState';
import { HEAP_SEE_MORE_BTN_CLICK } from '../../constants/analytics';
import {
    EVENTBRITE_CAROUSEL_CATEGORY_EMPTY_STATE,
    HOME_PAGE_CATEGORY_CAROUSEL,
} from '../../constants/category';
import { LazyCategoryEventBucket } from '../CategoryEventsContainer';
import { LazyLoadedCollectionsBucket } from '../CollectionsBucketContainer';
import './CategoryCarouselContainer.scss';

interface CategoryCarouselContainerProps {
    dataTestId?: string;
    hasCategoryEvents?: boolean;
    location?: Location;
}
const CategoryCarouselContainer = ({
    dataTestId,
    hasCategoryEvents,
    location,
}: CategoryCarouselContainerProps) => {
    const handleOnClick = () => {
        logEvent(HEAP_SEE_MORE_BTN_CLICK);
        //todo
    };

    return (
        <div
            id="category-carousel"
            className="categoryCarousel"
            data-testid={dataTestId}
        >
            <Layout hasHorizontalGutters={true} maxWidth="large">
                {!hasCategoryEvents && (
                    <EmptyState
                        bucketKey="category-carousel"
                        isAuthenticated={false}
                        emptyState={EVENTBRITE_CAROUSEL_CATEGORY_EMPTY_STATE}
                    />
                )}

                <LazyRenderer numChildInitialRender={2}>
                    {HOME_PAGE_CATEGORY_CAROUSEL.map((category, index) => (
                        <LazyCategoryEventBucket
                            key={category.key}
                            queryOverload={category.eventSearch}
                            categoryTitle={category.name}
                            categoryKey={category.key}
                            categoryIcon={category.icon}
                            viewMore={category.viewMore}
                            bucketPosition={index}
                        />
                    ))}
                    {hasCategoryEvents && (
                        <>
                            <LazyLoadedCollectionsBucket />
                            <div className="horizontalBar"></div>
                            <CategoryCarouselSeeMore
                                onClick={handleOnClick}
                                label={gettext('View More')}
                                title={location?.currentPlace}
                                seeMoreUrl={getCanonicalSearchUrl({
                                    slug: location?.slug,
                                    moreEventsHomePage: true,
                                })}
                            />
                            <div className="horizontalBar"></div>
                        </>
                    )}
                </LazyRenderer>
            </Layout>
        </div>
    );
};

const _mapStateToProps = ({ content, location }: DiscoverState) => {
    return {
        hasCategoryEvents: content?.carouselCategoryState?.isCarouselCategory,
        location: location,
    };
};

export default connect(_mapStateToProps)(CategoryCarouselContainer);
